import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { from, Observable, of } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { EnumInjectionTokens } from '../constants';
import { IEnvironment } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private readonly oauthService: OAuthService,
    private readonly router: Router,
    @Inject(EnumInjectionTokens.Environment) private environment: IEnvironment
  ) { }

  isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  authenticate(): Observable<boolean> {
    const config = this.environment.authCodeFlowConfig;
    (config as any).redirectUri = window.location.href.replace(/(&|\?)?(code|state)=[^\n]+/, '');
    this.oauthService.configure(this.environment.authCodeFlowConfig);

    if (config.showDebugInformation) {
      this.oauthService.events.subscribe(e => {
        // eslint-disable-next-line no-console
        console.log('oauth/oidc event', e);
      });
    }

    if (!this.oauthService.hasValidAccessToken()) return from(this.login());
    return this.tryTokenRefresh();
  }

  private tryTokenRefresh(): Observable<boolean> {
    if (this.oauthService.hasValidAccessToken()) return of(true);

    return from(this.oauthService.refreshToken()).pipe(
      tap(x => console.log(`test ${x}`))
      , catchError(e => {
        console.log(`error ${e}`);
        return e;
      })
      , map(() => false)
    );
  }

  async login(): Promise<boolean> {
    const isLoaded = await this.oauthService
      .loadDiscoveryDocumentAndLogin()
      .catch(error => new Error('Exception: ' + error.message));

    return !!isLoaded;
  }

  redirectToLogin() {
    console.log('redirectToLogin - 1', this.oauthService.loginUrl);
    const loginUrl = this.oauthService.issuer;
    
    this.router.navigateByUrl('unauthorized');
  }
}
